


























import { Component, Prop, Vue } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app";
import SidebarItem from "./SidebarItem.vue";
import variables from "@/styles/_variables.scss";
import SidebarLogo from "./SidebarLogo.vue";
import { PermissionModule } from "@/store/modules/permission";
import { SettingsModule } from "@/store/modules/settings";
import Layout from "@/layout/index.vue";
@Component({
  name: "SideBar",
  components: {
    SidebarItem,
    SidebarLogo,
  },
})
export default class extends Vue {
  created() {
    this.routess();
  }
  // monuted() {
  //   this.routess();
  // }
  private routersa: any = [];
  private royterpath = "";
  private routess() {
    let adminexpert = {
      path: "/adminManage",
      redirect: "noredirect",
      name: "adminManage",
      component: Layout,
      meta: {
        title: "管理员信息管理",
        icon: "adminmanage",
      },
      children: [
        {
          path: "expertmanage",
          component: () => import("@/views/adminManage/expertmanage/index.vue"),
          name: "expertmanage",
          meta: {
            title: "点评员管理",
            icon: "expert",
          },
        },
      ],
    };
    let adminManage = {
      path: "/adminManage",
      redirect: "noredirect",
      name: "adminManage",
      component: Layout,
      meta: {
        title: "管理员信息管理",
        icon: "admin",
      },
      children: [
        {
          path: "adminManage",
          component: () => import("@/views/adminManage/adminmange/index.vue"),
          name: "adminManage",
          meta: {
            title: "管理员管理",
            icon: "adminmanage",
            requireAuth: true,
          },
        },
        {
          path: "expertmanage",
          component: () => import("@/views/adminManage/expertmanage/index.vue"),
          name: "expertmanage",
          meta: {
            title: "点评员管理",
            icon: "expert",
            requireAuth: true,
          },
        },
      ],
    };
    let equipAnalyseManage = {
      path: "/equipAnalyseManage",
      redirect: "noredirect",
      name: "equipAnalyseManage",
      component: Layout,
      children: [
        {
          path: "equipAnalyseManage",
          component: () => import("@/views/equipAnalyseManage/index.vue"),
          name: "equipAnalyseManage",
          meta: {
            title: "器材类型统计",
            icon: "equipmanage",
            requireAuth: true,
          },
        },
      ],
    };
    let examineeManage = {
      path: "/examineeManage",
      redirect: "noredirect",
      name: "examineeManage",
      component: Layout,
      children: [
        {
          path: "examineeManage",
          component: () => import("@/views/examineeManage/index.vue"),
          name: "examineeManage",
          meta: {
            title: "学生管理",
            icon: "examinee",
            requireAuth: true,
          },
        },
      ],
    };
    let equiptypeManage = {
      path: "/equiptypeManage",
      redirect: "noredirect",
      name: "equiptypeManage",
      component: Layout,
      children: [
        {
          path: "equiptypeManage",
          component: () => import("@/views/equiptypeManage/index.vue"),
          name: "Apparatus",
          meta: {
            title: "器材类型管理",
            icon: "equiptype",
            requireAuth: true,
          },
        },
      ],
    };
    let equipManage = {
      path: "/equipManage",
      redirect: "noredirect",
      name: "equipManage",
      component: Layout,
      children: [
        {
          path: "equipManage",
          component: () => import("@/views/equipManage/index.vue"),
          name: "Apparatus",
          meta: {
            title: "器材管理",
            icon: "equip",
            requireAuth: true,
          },
        },
      ],
    };
    let injuryManage = {
      path: "/injuryManage",
      redirect: "noredirect",
      name: "injuryManage",
      component: Layout,
      children: [
        {
          path: "injuryManage",
          component: () => import("@/views/injuryManage/index.vue"),
          name: "injuryManage",
          meta: {
            title: "伤情管理",
            icon: "injury",
            requireAuth: true,
          },
        },
      ],
    };
    let ratsheetManage = {
      path: "/ratsheetManage",
      redirect: "noredirect",
      name: "ratsheetManage",
      component: Layout,
      children: [
        {
          path: "ratsheetManage",
          component: () => import("@/views/ratsheetManage/index.vue"),
          name: "ratsheetManage",
          meta: {
            title: "评估标准管理",
            icon: "sheet",
            requireAuth: true,
          },
        },
      ],
    };
    let resultsAnalyse = {
      path: "/resultsAnalyse",
      redirect: "noredirect",
      name: "resultsAnalyse",
      component: Layout,
      children: [
        {
          path: "resultsAnalyse",
          component: () => import("@/views/resultsAnalyse/index.vue"),
          name: "resultsAnalyse",
          meta: {
            title: "训练考核成绩管理",
            icon: "result",
            requireAuth: true,
          },
        },
      ],
    };
    let trainplanManage = {
      path: "/trainplanManage",
      redirect: "noredirect",
      name: "trainplanManage",
      component: Layout,
      children: [
        {
          path: "trainplanManage",
          component: () => import("@/views/trainplanManage/index.vue"),
          name: "trainplanManage",
          meta: {
            title: "训练计划管理",
            icon: "train",
            requireAuth: true,
          },
        },
      ],
    };
    let userinfo = {
      path: "/userinfo",
      redirect: "noredirect",
      name: "userinfo",
      component: Layout,
      children: [
        {
          path: "userinfo",
          component: () => import("@/views/userinfo/index.vue"),
          name: "userinfo",
          meta: {
            title: "个人中心",
            icon: "userinfo",
            requireAuth: true,
          },
        },
      ],
    };
    let tissuemanage = {
      path: "/tissuemanage",
      redirect: "noredirect",
      name: "tissuemanage",
      component: Layout,
      children: [
        {
          path: "tissuemanage",
          component: () => import("@/views/tissuemanage/index.vue"),
          name: "tissuemanage",
          meta: {
            title: "课题申报",
            icon: "tissue",
            requireAuth: true,
          },
        },
      ],
    };
    // let delcare = {
    //   path: "/delcare",
    //   redirect: "noredirect",
    //   name: "delcare",
    //   component: Layout,
    //   children: [
    //     {
    //       path: "delcare",
    //       component: () => import("@/views/delcare/index.vue"),
    //       name: "delcare",
    //       meta: {
    //         title: "课题申报",
    //         icon: "tissue",
    //         requireAuth: true,
    //       },
    //     },
    //   ],
    // };

    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    const showpower = parma.orgnizeid.split(",");
    // showpower.length=0是游客身份 1超级管理员 2学校管理员 3集团军管理员 4合成旅管理员
    if (parma.orgnizeid === "") {
      this.routersa.push(userinfo);
    } else if (parma.orgnizeid == "0") {
      this.routersa.push(tissuemanage, adminManage, userinfo);
    } else if (showpower.length === 1) {
      this.routersa.push(
        tissuemanage,
        equipAnalyseManage,
        adminManage,
        examineeManage,
        equiptypeManage,
        injuryManage,
        ratsheetManage,
        resultsAnalyse,
        trainplanManage,
        userinfo
      );
    } else if (showpower.length === 2) {
      this.routersa.push(
        tissuemanage,
        equipAnalyseManage,
        adminManage,

        examineeManage,
        ratsheetManage,
        resultsAnalyse,
        trainplanManage,
        userinfo
      );
    } else if (showpower.length === 3) {
      this.routersa.push(
        tissuemanage,
        equipAnalyseManage,
        adminexpert,
        examineeManage,
        ratsheetManage,
        equipManage,
        resultsAnalyse,
        trainplanManage,
        userinfo
      );
    }
  }
  get sidebar() {
    return AppModule.sidebar;
  }
  get showLogo() {
    return SettingsModule.showSidebarLogo;
  }
  get routes() {
    PermissionModule.routes.forEach((res: any) => {
      console.log(res);
    });

    return PermissionModule.routes;
  }

  get variables() {
    return variables;
  }
  get activeMenu() {
    const route = this.$route;
    const { meta, path } = route;
    // if set path, the sidebar will highlight the path you set
    if (meta.activeMenu) {
      return meta.activeMenu;
    }
    return path;
  }
  get isCollapse() {
    return !this.sidebar.opened;
  }
}
